<template>
    <!-- 订单 -->
    <div class="font-normal">
        <div v-for="(item1, i) in item.content" :key="i" class="pointer talk-order flex-start-center bg-gray padding-10 border-r-5" @click="openGoodsModal(item1)">
            <div class="link-img img-fit-contain flex-shrink-0" style="height: 60px; width: 60px">
                <img :src="item1.MUrl">
            </div>
            <div class="padding-rl-10 font-12">
                <p>订单编号：{{item1.OrderId}}</p>
                <p class="padding-tb-5">共{{item1.Nums}}件商品</p>
                <p>商品合计：￥{{item1.FinalAmount}}</p>
            </div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'msgOrder',
  methods: {
    openGoodsModal(item) {
      let link = `http://mall.yingerfashion.com/yinger-m/index.html#/detailView?goods_id=${ item.goods_id }`
      window.open(link, '_blank', 'width=400,height=667,resizable=0,location=0')
    }
  }
}
</script>

<style scoped>
</style>
